import React, { useState } from "react";
import { Alert, Segmented, Space } from "antd";

import StatCards from "./StatCards";
import RecentActivities from "./RecentActivities";
import useMyTransactions from "../../../hooks/useMyTransactions";
import useMyJobApplications from "../../../hooks/useMyJobApplications";

/**
 * Toutes les activités : ventes, achats, commandes et livraisons du marketplace, et, pour un
 * particulier, les travaux (ses candidatures aux offres de travaux champêtres et leur décision).
 */
const Activities = () => {
    const { transactions, sales, purchases, loading, error, userId } = useMyTransactions();
    const {
        applications: jobApplications,
        accepted: acceptedJobApplications,
        loading: jobsLoading,
        error: jobsError,
        isIndividual
    } = useMyJobApplications();
    const [type, setType] = useState("all");

    const stats = [
        { title: "Ventes", value: sales.length },
        { title: "Achats", value: purchases.length },
        { title: "Commandes", value: transactions.filter((transaction) => transaction.orderId).length },
        {
            title: "Livraisons effectuées",
            value: transactions.filter((transaction) => transaction.deliveryStatus === "DELIVERED").length
        },
        ...(isIndividual ? [{ title: "Travaux acceptés", value: acceptedJobApplications.length }] : [])
    ];

    const typeOptions = [
        { label: "Toutes", value: "all" },
        { label: "Ventes", value: "sales" },
        { label: "Achats", value: "purchases" },
        ...(isIndividual ? [{ label: "Travaux", value: "works" }] : [])
    ];

    const shownTransactions = type === "sales" ? sales
        : type === "purchases" ? purchases
            : type === "works" ? []
                : transactions;
    const shownJobApplications = type === "all" || type === "works" ? jobApplications : [];

    return (
        <Space orientation="vertical" size={20} style={{ width: "100%" }}>
            {error && <Alert type="warning" showIcon title="Impossible de charger vos activités pour le moment." />}
            {jobsError && <Alert type="warning" showIcon title="Impossible de charger vos travaux pour le moment." />}
            <StatCards stats={stats} loading={loading || jobsLoading} />
            <Segmented options={typeOptions} value={type} onChange={setType} />
            <RecentActivities
                title="Historique des activités"
                transactions={shownTransactions}
                jobApplications={shownJobApplications}
                loading={loading || jobsLoading}
                userId={userId}
            />
        </Space>
    );
};

export default Activities;
